import { RmsCellTemplateDirective } from '../../../../../custom-modules/rms-module/rms-table/rms-table.directives';
import { InventoryWebsiteVisibilityComponent } from '../../inventory-website-visibility.component';
import { PurchaseOrderLookupsService } from '../shared/purchase-order-lookups.service';
import { InventoryFamilyTreeComponent } from '../../inventory-management/inventory-data/inventory-family-tree/inventory-family-tree.component';
import {purchaseOrderTraders} from '../shared/purchase-order-traders';
import { cloneDraft, sameInventory, upsertInventory, childInventoryType } from '../shared/purchase-order-state';
import { Component, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { audit, lastValueFrom } from 'rxjs'
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { RmsModule } from "@rms";
import { PurchaseOrder, Column, Supplier, CoffeeTrader, Inventory, TableIcon } from '@interfaces';
import { WebService, PopupService, DataService, ReportService, RmsMessageService, PromptService } from "@services";
import { InventoryFormComponent } from '../inventory-form/inventory-form.component';
import { createEmptyPurchaseOrder } from '../../../../../shared/utils/factory/purchase-order.factory'
import { environment } from '../../../../../../environments/environment'

@Component({
  selector: 'app-purchase-order-form',
  imports: [RmsCellTemplateDirective, InventoryWebsiteVisibilityComponent, RmsModule, FormsModule, MatIconModule, MatButtonModule, InventoryFormComponent, InventoryFamilyTreeComponent],
  templateUrl: './purchase-order-form.component.html',
  styleUrls: ['./purchase-order-form.component.scss']
})
export class PurchaseOrderFormComponent implements OnInit, OnChanges {

  @Input() PurchaseOrder: PurchaseOrder = createEmptyPurchaseOrder();
  @Input() OfferSample: any = null;

  @Output() ReturnToList = new EventEmitter<any>;
  @Output() OnSavePO = new EventEmitter<any>;
  @Output() OnRefreshPO = new EventEmitter<void>();
  @Output() onReturnToSpread = new EventEmitter<any>;

  private env: string = this.getEnvironment(environment.WS_URL);
  offer: any = null;
  viewFile: boolean = false;
  viewFilePath: string = '';
  FilesColumns: Column[] = [
    { label: 'File Name', key: "name", width: 60 },
  ]
  FilesIcons: TableIcon[] = [
      { action: (row: any, index: number) => this.onViewFile(row, index), icon: 'open_in_new', title: 'View File Information.' }
  ]
  InventoryColumns: Column[] = []
  InventoryForTable: any[] = [];
  ChildInventoryColumns: Column[] = [];
  DefaultValues: any = {};
  InventoryIcons: TableIcon[] = [
    { action: (row: any, index: number) => this.onViewInventory(row, index), icon: 'open_in_new', title: 'View Inventory Information.' }
  ]
  AuditColumns: Column[] = [
    { label: 'Date\\Time', key: 'event_time', width: 15, type: "date" },
    { label: 'Type', key: 'event_type', width: 10 },
    { label: 'Modified By', key: 'server_principal_name', width: 25 },
    { label: 'Client IP', key: 'client_ip', width: 10 },
    { label: 'Changes', key: 'statement', width: 40 }
  ]
  purchaseOrderFolder: any | null = null;
  suppliers: Supplier[] | null = null;
  coffeeTraders: any[] | null = null;
  auditLog: any | null = null;
  auditLoading = false;
  auditError = '';
  private auditLoadedId = '';
  SelectedInventory: any | null = null
  openInventoryForm: boolean = false;
  inventoryViewIndex: number | null = null;
  PurchaseOrdersToConnect: any[] = [];
  inventoryIds: any[] = [];
  loading: boolean = true;
  autoExpand: boolean = false;
  Updated: boolean = false;
  saving = false;
  saveOutcomeUnknown = false;
  finalizing = false;
  landedCostSaving = false;
  loadError = '';

  Accounting: boolean = false;
  AddLandedCost: boolean = false;
  constructor(private web: WebService, private sanitizer: DomSanitizer, private popup: PopupService, private rnyData: DataService, private report: ReportService, private message: RmsMessageService, private prompt: PromptService, private lookups?: PurchaseOrderLookupsService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['PurchaseOrder']) this.CreateInventoryColumns();
  }

  async refreshLandedCosts(): Promise<void> {
    const rows = await lastValueFrom(this.web.getWebCall('inventory', 'coffee/purchase-order/', {
      params: [{ name: 'PurchaseOrderID', value: this.PurchaseOrder.PurchaseOrderID }]
    }));
    const saved = rows?.[0];
    if (!saved) throw new Error('The updated purchase order could not be loaded.');
    // Only replace persisted cost fields; unrelated draft edits remain in the form.
    const costs = ['LandedCost', 'ActualLandedCost', 'FOBtoExWarehouseValueTemp', 'ExWhseCost',
      'FinalWarehouseInCost', 'FinalWarehouseInDifferential', 'EstimatedCost',
      'FinalWarehouseInCostTemp', 'FinalWarehouseInDifferentialTemp', 'EstimatedCostTemp'];
    const savedInventory = (saved.Inventory ?? []).flatMap((row: any) => [row, ...(row.ChildInventory ?? [])]);
    const refreshRow = (row: any): any => {
      const persisted = savedInventory.find((item: any) => sameInventory(item, row));
      const refreshed = { ...row };
      if (persisted) costs.forEach(field => {
        if (Object.prototype.hasOwnProperty.call(persisted, field)) refreshed[field] = persisted[field];
      });
      if (row.ChildInventory) refreshed.ChildInventory = row.ChildInventory.map(refreshRow);
      return refreshed;
    };
    this.PurchaseOrder = { ...this.PurchaseOrder, MarineInsurance: saved.MarineInsurance ?? null, CustomsEntry: saved.CustomsEntry ?? null, FreightCharge: saved.FreightCharge ?? null, Drayage: saved.Drayage ?? null, MiscInboundCharge: saved.MiscInboundCharge ?? null, InboundTariff: saved.InboundTariff ?? null,
      Inventory: (this.PurchaseOrder.Inventory ?? []).map(refreshRow) };
    this.CreateInventoryColumns();
    this.auditLoadedId = '';
    this.auditLog = null;
    this.OnRefreshPO.emit();
  }

  async ngOnInit() {
    this.loading = true;
    this.loadError = '';
    const groups = JSON.parse(sessionStorage.getItem("userGroups") || "[]");
    this.Accounting = groups.some((group: any) => group.displayName === "System Admins" || group.displayName === "Accounting" || group.displayName === "Executive");
    void this.getPurchaseOrdersToConnect();
    if (this.PurchaseOrder.PurchaseOrderID) {
      void this.getFiles();
    }
    if (this.PurchaseOrder.PurchaseOrderID) {
      try {
        await Promise.all([
          this.getTraders(),
          this.getSuppliers()
          
        ]);
        this.loading = false
        this.CreateInventoryColumns();
      }
      catch (err) {
        this.loading = false;
        this.loadError = 'Unable to load purchase order details. Please retry.';
        this.message.error(this.loadError);
      }
    }
    else {
      try {
        await Promise.all([
          this.getTraders(),
          this.getSuppliers()
        ])
        this.loading = false;
        if (this.OfferSample) {
          this.offer = this.OfferSample;
          this.PurchaseOrder = {
            ...createEmptyPurchaseOrder(),
            SupplierID: this.offer.SupplierID,
          }
          this.onNewInventory();
          this.OfferSample = null;
        }
        this.CreateInventoryColumns();
      } catch (err){
        this.loading = false;
        this.loadError = 'Unable to load purchase order details. Please retry.';
        this.message.error(this.loadError);
      }
    }
  }
  private getEnvironment(envUrl: string): string {
    switch (envUrl) {
      case 'http://localhost:5150': return 'DEV';
      case 'https://dev-exp.royalny.net': return 'WEB-DEV';
      case 'https://qa-exp.royalny.net': return 'WEB-QA';
      default: return 'PROD';
    }
  }
  async savePurchaseOrder(inv? :any) {
    if (this.saving || this.saveOutcomeUnknown) return;
    this.saving = true;
    let persisted = false;
    try {
      const update = !!this.PurchaseOrder.PurchaseOrderID;

      // Keep explicit parent/child relationships for the transactional save endpoint.
      const bodyForSave = {
        ...this.PurchaseOrder,
        Inventory: cloneDraft(this.PurchaseOrder.Inventory ?? []),
      };
      if (inv) {
        if (bodyForSave.Inventory!.filter((i: any) => !i.DecaffeinatorID).length > 0 && inv.FOBtoExWarehouseValueTemp != null) {
          bodyForSave.Inventory!.filter((i: any) => !i.DecaffeinatorID).forEach((i: any) => {
            i.FOBtoExWarehouseValueTemp = inv.FOBtoExWarehouseValueTemp;
          })
        }
      }
      // 1) Save (create/update)
      const created = await lastValueFrom(
        this.web.getWebCall('inventory', 'coffee/purchase-order/save', { body: bodyForSave })
      );

      const newId = created?.[0]?.PurchaseOrderID;
      if (!newId) throw new Error('No PurchaseOrderID returned from create');
      persisted = true;
      this.PurchaseOrder.PurchaseOrderID = newId;

      // 2) Reload full PO (flat from API)
      const PO = await lastValueFrom(
        this.web.getWebCall('inventory', 'coffee/purchase-order/', {
          params: [{ name: 'PurchaseOrderID', value: newId }]
        })
      );
      this.PurchaseOrder = PO?.[0] ?? this.PurchaseOrder;

      // 4) Rebuild UI (CreateInventoryColumns nests parents/children for the expand)
      this.Updated = false;
      this.OnSavePO.emit({ PurchaseOrderID: this.PurchaseOrder.PurchaseOrderID, update });
      if (this.PurchaseOrder.Inventory!.some((i: any) => i.ParentInventoryID != null)) this.autoExpand = true;
      this.CreateInventoryColumns();
    } catch (ex: any) {
      console.error(ex);
      this.saveOutcomeUnknown = persisted || ex?.status === 0;
      this.Updated = true;
      this.message.error('Unable to save purchase order: ' + (ex?.error?.error ?? ex?.message ?? 'Please retry.'));
    } finally { this.saving = false; }
  }

  async onSelectFile(event: any) {
    const params = [{ name: 'path', value: this.purchaseOrderFolder.folder }, { name: 'filename', value: event.name }];

    try {
      const blob = await lastValueFrom(this.web.getWebCall('files', 'download', { params: params, responseType: 'blob' }));

      const fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));

      this.popup.open({
        title: event.name,
        reportUrl: fileUrl
      });

    } catch (err) {
      console.error('Preview failed:', err);
    }
  }
  private async getTraders() {
    try {
      const users = await lastValueFrom(this.lookups ? this.lookups.get('users', 'users') : this.web.getWebCall('users', 'users'));
      const match = (users ?? []).find((u:any)=>String(u.GraphUserID).toLowerCase() === String(this.PurchaseOrder.TraderGUID).toLowerCase());
      if (match) this.PurchaseOrder.TraderGUID = match.GraphUserID;
      this.coffeeTraders = purchaseOrderTraders(users, this.PurchaseOrder.TraderGUID);
    }
    catch (error) {
      throw error;
    }
  }
  onTraderSelected() {
    this.markChanged();
  }
  private async getSuppliers() {
    try {
      this.suppliers = await lastValueFrom(this.lookups ? this.lookups.get('inventory', 'coffee/suppliers') : this.web.getWebCall('inventory', 'coffee/suppliers'));
    }
    catch (error) {
      throw error;
    }
  }
  private async getPurchaseOrdersToConnect() {
    try {
      const params = [{ name: 'PurchaseOrderID', value: this.PurchaseOrder.PurchaseOrderID ?? null }];
      this.PurchaseOrdersToConnect = await lastValueFrom(this.web.getWebCall('data', 'coffee/purchase-orders-for-connection', { params }));

      // ✅ Refresh model binding to force match after options are ready
      const selected = this.PurchaseOrdersToConnect.find(po =>
        po.PurchaseOrderID === this.PurchaseOrder.ConnectedPurchaseOrderID
      );
      if (selected) {
        this.PurchaseOrder.ConnectedPurchaseOrderID = selected.PurchaseOrderID;
      }
    } catch (error) {
      console.error(error);
    }
  }
  private async getFiles() {
    try {
      const params = [{ name: "path", value: 'purchase-orders' }, { name: 'folderName', value: `po-${this.PurchaseOrder.PurchaseOrderID}` }]
      this.purchaseOrderFolder = await lastValueFrom(this.web.getWebCall('files', 'listByPathAndFolder', { params: params }));
    }
    catch (error) {
      console.error(error);
    }
  }
  onTabSelected(label: string): void {
    if (label === 'Audit log') void this.loadAuditLog();
  }

  async loadAuditLog(): Promise<void> {
    const id = String(this.PurchaseOrder.PurchaseOrderID || '');
    if (!id || this.auditLoading || this.auditLoadedId === id) return;
    this.auditLoading = true;
    this.auditError = '';
    try {
      const rows = await lastValueFrom(this.rnyData.getAuditLog('purchase_order', 'PurchaseOrderID', id));
      if (!Array.isArray(rows)) throw new Error('Audit history could not be loaded.');
      if (id !== String(this.PurchaseOrder.PurchaseOrderID)) return;
      this.auditLog = rows.map((row: any) => ({ ...row,
        statement: this.extractSetClause(row.statement || '') || row.statement }));
      this.auditLoadedId = id;
    } catch {
      this.auditError = 'Could not load audit history. Please try again.';
    } finally {
      this.auditLoading = false;
    }
  }

  extractSetClause(sqlStatement: string): string | null {
    const regex = /(?<=SET\s)(.*?)(?=\sWHERE)/;
    const match = sqlStatement.match(regex);
    return match ? match[0] : null;
  }

  private canLeave(): boolean {
    return !this.saving && (!(this.Updated || !this.PurchaseOrder.PurchaseOrderID) ||
      confirm('Discard unsaved purchase order changes?'));
  }
  onReturnToList() { if (this.canLeave()) this.ReturnToList.emit({ PurchaseOrderID: null }); }
  ReturnToSpread() { if (this.canLeave()) this.onReturnToSpread.emit(this.PurchaseOrder); }
  markChanged() { this.Updated = true; }
  setInventoryWebsiteVisibility(row: any, invisible: boolean): void {
    row.WebInvisible = invisible;
    this.updateInventoryField(row, 'WebInvisible');
  }
  private updateInventoryField(row: any, field: string): void {
    const inventory = this.PurchaseOrder.Inventory?.find((item: any) => sameInventory(item, row));
    if (inventory) { inventory[field] = row[field]; this.markChanged(); }
  }
  onNewInventory() {
    if (this.saving || this.saveOutcomeUnknown) return;
    this.SelectedInventory = null;
    this.DefaultValues = this.PurchaseOrder.Inventory?.[0] ? { ...this.PurchaseOrder.Inventory?.[0], PurchaseOrderInventories: this.PurchaseOrder.Inventory.filter((i : any) => !i.ParentInventoryID) } : {};
    this.openInventoryForm = true;
  }
  onViewInventory(Inventory: any, index: number) {
    if (this.saving || this.saveOutcomeUnknown) return;
    this.inventoryViewIndex = index
    this.SelectedInventory = cloneDraft(Inventory);
    this.SelectedInventory.Index = index;
    this.DefaultValues = { ...this.SelectedInventory, PurchaseOrderInventories: this.PurchaseOrder.Inventory!.filter((i: any) => !i.ParentInventoryID) }
    if (this.SelectedInventory.ChildInventory) {
      if (this.SelectedInventory.ChildInventory.some((i: any) => i.DecaffeinatorID != null)) {
        this.SelectedInventory.Child = this.SelectedInventory.ChildInventory.find((ci: any) => ci.DecaffeinatorID != null);
        this.SelectedInventory.Decaf = true;
        this.SelectedInventory.DecafID = this.SelectedInventory.Child.InventoryTypeID;
        delete this.SelectedInventory.ChildInventory
      }
    }
    this.openInventoryForm = true
  }
  onLeaveInventoryForm(){
    this.SelectedInventory = null;
    this.openInventoryForm = false;
    this.CreateInventoryColumns();
  }
  async onUpdateInventoryForm(inv: any) {
    if (this.saving) return;
    if (inv.__deleteChildId) {
      this.message.error('Removing an existing decaf child requires a separate validated deletion workflow. Your edits remain open.');
      return;
    }
    this.PurchaseOrder.Inventory = upsertInventory(this.PurchaseOrder.Inventory ?? [], inv);
    this.Updated = true;
    await this.savePurchaseOrder(inv);
    if (!this.Updated) { this.openInventoryForm = false; this.SelectedInventory = null; }
  }
  async onSaveInventoryForm(inv: any) {
    this.PurchaseOrder.Inventory = upsertInventory(this.PurchaseOrder.Inventory ?? [], inv);
    this.Updated = true;
    this.CreateInventoryColumns();
    this.openInventoryForm = false;
    this.SelectedInventory = null;
  }

  SaveInventory(Inventory: any) {
    if (!Array.isArray(this.PurchaseOrder.Inventory)) {
      this.PurchaseOrder.Inventory = [];
    }
    if (Inventory.Index !== undefined && Inventory.Index !== null) {
      this.PurchaseOrder.Inventory[Inventory.Index] = Inventory;
    }
    else {
      this.PurchaseOrder.Inventory.push(Inventory);
    }
    this.openInventoryForm = false;
    if (Inventory.InventoryID) {
      this.savePurchaseOrder();
    }
    this.CreateInventoryColumns();
  }

  onNewPurchaseOrder() {
    if (!this.canLeave()) return;
    this.PurchaseOrder = createEmptyPurchaseOrder();
    this.Updated = false;
    this.CreateInventoryColumns();
  }
  FinalizeUser(): boolean {
    const origin = this.PurchaseOrder?.Inventory![0].Origin;
    if (!origin) return false;

    const groups = localStorage.getItem("userGroups") || "[]";

    // Check if user has a group like "Coffee-[Origin]"
    const requiredGroup = `Coffee-${origin}`;
    return groups.includes(requiredGroup);
  }
  async OpenConfirm() {

    let blob = await lastValueFrom(this.report.getReport('NewPurchaseOrderReport', [{ name: 'purchaseOrderID', value: this.PurchaseOrder.PurchaseOrderID }, { name: "envir", value: this.env }], 'pdf'));
    const url = URL.createObjectURL(blob);
    this.popup.open({
      title: 'Purchase Order Confirm',
      reportUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url),
      startingHeight: "800px"
    });
  }
  async OpenSpreadConfirm() {

    let blob = await lastValueFrom(this.report.getReport('PurchaseOrderCoverConfirm', [{ name: 'PurchaseOrderSpread', value: this.PurchaseOrder.PurchaseOrderSpread }, { name: "envir", value: this.env }, {name: 'purchaseOrderID', value: -1}], 'pdf'));
    const url = URL.createObjectURL(blob);
    this.popup.open({
      title: 'Purchase Order Confirm',
      reportUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url),
      startingHeight: "800px"
    });
  }
  private CreateInventoryColumns() {
    const invs = Array.isArray(this.PurchaseOrder?.Inventory)
      ? this.PurchaseOrder.Inventory
      : [];

    const parentsMap = new Map<string | number, any>();
    const childrenFlat: any[] = [];

    for (const inv of invs) {
      if (inv?.ParentInventoryID) {
        // flat child coming back from server
        childrenFlat.push(inv);
      } else {
        // 🔧 keep any nested ChildInventory that your local editor already put there
        const existingKids = Array.isArray(inv.ChildInventory)
          ? inv.ChildInventory.map((c: any) => ({ ...c }))
          : [];

        const key = inv.InventoryID ?? inv._tempKey;  // support unsaved rows
        parentsMap.set(key, { ...inv, ChildInventory: existingKids });
      }
    }

    // Attach any flat children (from API) under the right parent
    for (const child of childrenFlat) {
      const parentKey = child.ParentInventoryID; // must be a real parent row from API
      const parent = parentsMap.get(parentKey);
      if (parent) {
        parent.ChildInventory.push(child);
      } else {
        // Orphan safeguard: show it as a parent row by itself
        const key = child.InventoryID ?? child._tempKey;
        parentsMap.set(key, { ...child, ChildInventory: [] });
      }
    }

    // ---- inside CreateInventoryColumns ----
    const toDisplay = (inv: any, parent?: any) => {
      // prefer parent's commercial terms when provided
      const src = parent ?? inv;

      const buyingTerm = src.BuyingTermID;
      const futureName = src.FutureCompositeName ?? '';
      const diffUnit = src.DifferentialPerUnit ?? null;
      const pricePer = src.PricePerUnit ?? null;

      const priceHeader = buyingTerm == 1 ? 'Cost' : 'Differential';
      const diffLabel = diffUnit == null ? '' : `${futureName}${diffUnit >= 0 ? '+' : ''}${diffUnit}`;
      const pricePound = pricePer;

      const base = {
        ...inv,
        ChildType: inv.ParentInventoryID || (parent && parent !== inv) ? childInventoryType(inv, parent) : '',

        // ---- mirror parent for cost/diff ----
        BuyingTermID: buyingTerm,
        PriceDescriptor: src.PriceDescriptorName,
        PriceHeader: priceHeader,
        PriceLabel: buyingTerm == 1 ? pricePound : diffLabel,

        // keep both in case parent table uses either path
        PricePoundLabel: pricePound,
        DifferentialPerPoundLabel: diffLabel,

        // existing fields you already had:
        ShippingHeader: inv.ShipmentTypeID == 1 && inv.ShippingTerm != 4 ? 'FOBtoExWarehouse ($\\lb.)' : 'ExWarehouse ($\\lb.)',
        ShippingLabel: inv.ShipmentTypeID == 1 && inv.ShippingTerm != 4 ? inv.FOBtoExWarehouseValueTemp : inv.ExWhseCost,
        LandedHeader: buyingTerm == 1 ? 'Estimated Landed Cost ($\\lb.)' : 'Estimated Landed Diff ($\\lb.)',
        LandedLabel: buyingTerm == 1 ? inv.FinalWarehouseInCost : inv.FinalWarehouseInDifferential,

        ShipLabel: this.formatMonthYearCode?.(inv.ETDMonth, inv.ETDYear) ?? (inv.FinalPosition ?? ''),
        DestinationWarehouse: inv.LocationName ?? '',
        WarehouseLabel: inv.LocationName ?? '',

        TariffInPrice: this.PurchaseOrder?.TariffInPrice ?? false,
        DecafLabel: this.hasDecafChild(inv) ? 'DCF' : '',
        CellClass: this.hasDecafChild(inv) ? 'cell-decaf' : '',
      };

      // Persisted references may have lineage outside this PO's child list.
      (base as any).expandable = Number(inv.InventoryID) > 0 || !!inv.ChildInventory?.length;
      (base as any).expanded = false;
      return base;
    };

    // When you build InventoryForTable, pass parent into children:
    this.InventoryForTable = Array.from(parentsMap.values()).map((p: any) => {
      const parentDisplay = toDisplay(p, p);          // parent uses itself
      const kids = Array.isArray(p.ChildInventory)
        ? p.ChildInventory.map((c: any) => toDisplay(c, p))  // children mirror parent terms
        : [];
      return { ...parentDisplay, ChildInventory: kids };
    });
    this.autoExpand = this.InventoryForTable.some(p => (p.ChildInventory?.length ?? 0) > 0);
    setTimeout(() => {
      // use first parent row for dynamic labels/keys just like CreateSpreadData
      const r0 = this.InventoryForTable?.[0] ?? {};

      this.InventoryColumns = [
        { label: 'Ref #', key: 'InventoryID', width: 5 },
        {
          label: 'Supplier Ref#', type: 'text', key: 'SupplierReffNumber', edit: true, width: 5,
          onAction: (row: any) => {
            // mirror CreateSpreadData behavior
            this.updateInventoryField(row, 'SupplierReffNumber');
          }
        },
        { label: 'Product', key: 'InventoryTypeName', width: 10 },

        // Ship / Destination
        { label: 'Ship Date', key: 'ShipLabel', width: 8 }, // make sure toDisplay sets ShipLabel (see note below)
        { label: 'Destination', key: 'DestinationWarehouse', width: 10 }, // toDisplay should set DestinationWarehouse

        { label: 'Bags', key: 'BagsOrdered', width: 5 },
        { label: 'Net Wt.', key: 'NetWeight', width: 5 },

        // Dynamic price / diff column (same logic as spread)
        {
          label: ((r0?.BuyingTermID == 2 ? 'Diff ' : 'Price ') + (r0?.PriceDescriptor ?? '')),
          key: (r0?.BuyingTermID == 2 ? 'DifferentialPerPoundLabel' : 'PricePoundLabel'),
          type: (r0?.BuyingTermID == 2 ? 'text' : 'currency'),
          width: 5
        },

        // Dynamic shipping column label & key (same as spread)
        {
          label: (r0?.ShipmentTypeID == 1 ? 'Handling / lb' : 'Ex-warehouse / lb'),
          key: (r0?.ShipmentTypeID == 1 ? 'FOBtoExWarehouseValueTemp' : 'ExWhseCost'),
          type: 'currency',
          format: '1.4-4',
          width: 10
        },

        // Landed column (same key switch as spread)
        {
          label: 'Landed / lb',
          key: (r0?.BuyingTermID == 2 ? 'FinalWarehouseInDifferential' : 'FinalWarehouseInCost'),
          type: 'currency',
          format: '1.4-4',
          width: 10
        },

        // Notes / toggles (same edit handlers concept)
        {
          label: 'Notes', type: 'textarea', key: 'Notes', edit: true, width: 10,
          onAction: (row: any) => {
            this.updateInventoryField(row, 'Notes');
          }
        },
        {
          label: 'Website visibility', type: 'checkbox', key: 'WebInvisible', edit: false, width: 9,
          onAction: (row: any) => {
            this.updateInventoryField(row, 'WebInvisible');
          }
        },
        {
          label: 'Tariff Included', type: 'checkbox', key: 'TariffInPrice', edit: true, width: 5,
          onAction: (row: any) => {
            // TariffInPrice lives on the PO in spread view; mirror that here
            if (this.PurchaseOrder) this.PurchaseOrder.TariffInPrice = row.TariffInPrice;
            this.Updated = true;
          }
        }
      ];

      // Child columns: match spread exactly (labels, order, widths)
      this.ChildInventoryColumns = [
        { label: 'Type', key: 'ChildType', width: 12 },
        { label: 'Ref #', key: 'InventoryID', width: 10, align: 'center' },
        { label: 'Product', key: 'InventoryTypeName', width: 20, align: 'center' },
        { label: 'Destination warehouse', key: 'WarehouseLabel', width: 20, align: 'center' }, // keep spread label spelling
        { label: 'Bags', key: 'BagsOrdered', width: 10, align: 'center' },
        { label: 'Net Wt', key: 'NetWeight', width: 10, type: 'number', fixed: 4, align: 'center' },
        { labelKey: 'PriceHeader', key: 'PriceLabel', width: 10, align: 'center' },
        { labelKey: 'ShippingHeader', key: 'ShippingLabel', width: 10, type: 'currency', format: '1.4-4', align: 'center' },
        { labelKey: 'LandedHeader', key: 'LandedLabel', width: 10, type: 'currency', format: '1.4-4', align: 'center' },
      ];
    }, 0);  }

  hasDecafChild(row: any): boolean {
    const kids = row?.ChildInventory;
    return Array.isArray(kids) && kids.some((ci: any) => ci?.DecaffeinatorID != null && ci.DecaffeinatorID !== 0);
  }
  formatMonthYearCode(month: number, year: number): string {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Normalize month (1–12)
    if (!month || month < 1 || month > 12 || !year) return '';

    // Normalize year to 2-digit string
    const yearStr = (year % 100).toString().padStart(2, '0');

    return `${monthNames[month - 1]}'${yearStr}`;
  }
  async finalizePurchaseOrder() {
    if (this.finalizing || this.saving || this.Updated) return;
    this.finalizing = true;
    try {
      let blob = await lastValueFrom(this.report.getReport('NewPurchaseOrderReport', [{ name: 'purchaseOrderID', value: this.PurchaseOrder.PurchaseOrderID }, { name: "envir", value: this.env }], 'pdf'));
      const form = new FormData();
      form.append('file', blob, `PO Confirm - ${this.PurchaseOrder.PurchaseOrderID}.pdf`);
      form.append('path', `purchase-orders/po-${this.PurchaseOrder.PurchaseOrderID}/`);
      form.append('fileName', `PO Confirm - ${this.PurchaseOrder.PurchaseOrderID}.pdf`);
      await lastValueFrom(this.web.getWebCall('files', 'upload', { body: form }))
      this.message.success("Purchase Order Finalized Successfully. PO Confirm Saved!");
    }
    catch (err) {
      this.message.error('Unable to save the confirmation PDF. Please retry.');
    } finally { this.finalizing = false; }
  }
  readonly inboundFields = [{"key":"MarineInsurance","label":"Marine insurance total"},{"key":"CustomsEntry","label":"Customs entry fees"},{"key":"FreightCharge","label":"Ocean freight"},{"key":"Drayage","label":"Drayage / trucking"},{"key":"MiscInboundCharge","label":"Miscellaneous inbound costs"},{"key":"InboundTariff","label":"Tariff fee"}] as const;
  get inboundTotal(): number {return this.inboundFields.reduce((sum,f)=>sum+Number(this.PurchaseOrder[f.key]??0),0);}
  get inboundCostPerPound(): number | null {
    const roots=(this.PurchaseOrder.Inventory??[]).filter((row:any)=>!row.ParentInventoryID);
    if(!this.inboundEntered || this.placeholderPO || !roots.length)return null;
    const weights=roots.map((row:any)=>Number(row.BagsInbounded??row.BagsOrdered)*Number(row.NetWeight));
    if(weights.some(w=>!Number.isFinite(w)||w<=0))return null;
    return this.inboundTotal/weights.reduce((sum,w)=>sum+w,0);
  }
  get inboundEntered(): boolean {return this.inboundFields.some(f=>this.PurchaseOrder[f.key]!=null && String(this.PurchaseOrder[f.key]).trim()!=='');}
  get placeholderPO(): boolean {return [27,15462,16052].includes(Number(this.PurchaseOrder.PurchaseOrderID));}
  async UpdateLandedCost() {
    if (this.landedCostSaving || !this.inboundEntered || this.inboundTotal < 0 || this.placeholderPO) return;
    const { closed$ } = this.prompt.open({
      promptText: 'Apply these inbound charges by weight to the purchase order inventory? Purchase price per pound stays separate.',
      buttons: [
        {
          value: true,
          label: 'Update',
          buttonClass: 'btn-bg-green'
        }
      ]
    });

    closed$.subscribe(async (confirmed: any) => {
      if (!confirmed || this.landedCostSaving) return;
      this.landedCostSaving = true;
      try {
        await lastValueFrom(
          this.web.getWebCall(
            'inventory',
            'coffee/purchase-order/update-landed-cost',
            {
              body: {
                PurchaseOrder: this.PurchaseOrder
              }
            }
          )
        );

        try {
          await this.refreshLandedCosts();
          this.message.success('Landed cost updated successfully.');
        } catch (refreshError) {
          this.message.error('Landed cost was saved, but the updated values could not be loaded. Reopen the purchase order to refresh them.');
        }
      }
      catch (err: any) {
        this.message.error(
          'Error updating landed cost: ' + (err?.error?.error ?? err?.message ?? 'Please retry.')
        );
      } finally { this.landedCostSaving = false; }
    });
  }
  async onViewFile(row: any, index: number) {
    this.viewFile = true;
    this.viewFilePath = row.path;
  }
}
